var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:{
  left:_vm.left,
  up: _vm.up,
  down: _vm.down
},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 49.02 54.15"}},[_c('path',{attrs:{"d":"M45,20.15,12,1.08A8,8,0,0,0,0,8V46.14a8,8,0,0,0,12,6.93L45,34A8,8,0,0,0,45,20.15Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }